import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import {
  LiveSettingListAllWrapper,
  LiveSettingLiveUpdateWrapper,
  LiveSettingListWrapper,
  LiveSettingListItemWrapper,
  LiveSettingListNameWrapper,
  LiveSettingToggleWrapper,
  LiveSettingToggleItem,
  LiveSettingToggleCircle,
} from "../style";
import { YoutubeLiveResponse } from "../../../../../../../api/youtube-live";
import { useTournamentContext } from "../../../../../hook/context";

const LiveList = () => {
  const { liveList, setLiveList } = useTournamentContext();

  const handleLinkValue = (index: number, value: string | null) => {
    if (index === -1) {
      return;
    }

    setLiveList((prevList: YoutubeLiveResponse[]) => {
      const newList = [...prevList];
      const item = newList[index];
      item.link = value ?? "";
      return newList;
    });
  };

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const newList = reorder(
      liveList,
      result.source.index,
      result.destination.index
    ).map((item, idx) => ({ ...item, order: idx + 1 }));
    setLiveList(newList);
  };

  const reorder = <T,>(
    list: T[],
    startIndex: number,
    endIndex: number
  ): T[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleLiveToggle = (index: number) => {
    setLiveList((prevList) => {
      const newList = [...prevList];
      const item = newList[index];

      item.isLive = !item.isLive;
      return newList;
    });
  };

  return (
    <LiveSettingListAllWrapper>
      <LiveSettingLiveUpdateWrapper>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="live-setting-list">
            {(provided) => (
              <LiveSettingListWrapper
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {liveList.map((item, i) => (
                  <Draggable
                    draggableId={item.id ? item.id?.toString() : "0"}
                    index={i}
                    key={i}
                  >
                    {(provided) => (
                      <LiveSettingListItemWrapper
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="ord">{i + 1}</div>
                        <LiveSettingListNameWrapper>
                          <div className="name">{item.name} </div>
                        </LiveSettingListNameWrapper>
                        <div className="link">
                          <input
                            type="text"
                            value={item.link}
                            onChange={(e) => handleLinkValue(i, e.target.value)}
                          />
                        </div>
                        <LiveSettingToggleWrapper isLiveOn={item.isLive}>
                          <div className="title">LIVE ON</div>
                          <LiveSettingToggleItem
                            isLiveOn={item.isLive}
                            onClick={() => handleLiveToggle(i)}
                          >
                            <LiveSettingToggleCircle isLiveOn={item.isLive} />
                          </LiveSettingToggleItem>
                        </LiveSettingToggleWrapper>
                      </LiveSettingListItemWrapper>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </LiveSettingListWrapper>
            )}
          </Droppable>
        </DragDropContext>
      </LiveSettingLiveUpdateWrapper>
    </LiveSettingListAllWrapper>
  );
};

export default LiveList;
